<mat-expansion-panel
	[togglePosition]="'before'"
	[expanded]="false"
	class="export-action-panel pl-4 level-3"
	*localVar="(item | transformObject: getItemFormats) as formats"
	[disabled]="formats.length < 2"
>
	<mat-expansion-panel-header class="pr-0">
		<div class="mt-1 action-details level-3">
			<div class="flex-grow flex export-title">
				<mat-icon
					*localVar="[item] | transformObject : ExportDownloadUtils.findItemByStatus : TaskStatus.Failed as isFailed"
					class="status-icon"
					[ngClass]="{ success: !isFailed, failure: isFailed }"
				>{{ isFailed ? 'clear' : 'check' }}
				</mat-icon>
				<span class="name">{{ (item.name | getLocale: item?.locale?.templateCreateUnit?.name) || item.itemData.name || item.metadata.name }}</span>
				<ng-container *ngIf="item | dimension as itemDimension">
					<span class="size">
						{{ itemDimension?.width + 'x' || '' }}{{ itemDimension?.height || '' }}{{ itemDimension?.defaultDisplayUnit || '' }}
					</span>
				</ng-container>
				<ng-container *ngIf="item.metadata.videoFormatText || item.metadata.videoResolution">
					<strong class="size">{{ item.metadata.videoFormatText }}</strong>
					<span *ngIf="item.metadata.videoResolution as videoResolution" class="size">
						{{ videoResolution }}
					</span>
				</ng-container>
			</div>
			<button
				color="primary"
				class="download-button"
				*ngIf="[item] | transformObject : ExportDownloadUtils.filterItemsByStatus : TaskStatus.Completed"
				(click)="$event.stopImmediatePropagation(); downloadItem.emit({ cartItem: item })"
			>
				<mat-icon inline>download</mat-icon>
			</button>

			<button
				mat-button
				color="tertiary"
				*ngIf="formats.length === 1 && ([item] | transformObject : ExportDownloadUtils.filterItemsByStatus : TaskStatus.Failed) as isFailed"
				class="size-small wrapper-tiny round-border"
				(click)="retryTasks.emit()"
			>
				<mat-icon inline>replay</mat-icon>
				<ng-container i18n="Retry Button Text@@exportDownloadRetryButtonText">Retry</ng-container>
			</button>
			<ng-container *ngIf="[item] | transformObject : ExportDownloadUtils.filterItemsByStatus : TaskStatus.Failed as isFailed">
				<div *ngIf="item.errors?.length" class="errors">
					<div *ngFor="let error of item.errors" class="error">
						<mat-icon class="status-icon" color="warn">error</mat-icon>
						<span>{{ error.message }}</span>
					</div>
				</div>
			</ng-container>

		</div>
	</mat-expansion-panel-header>
	<div class="action-details level-4 flex-column">
		<div class="format-row" *ngFor="let format of formats">
			<div class="flex full-width" *localVar="item | transformObject : getItemTaskFromFormat: format as formatTask">
				<mat-icon
					class="status-icon mr-2"
					[ngClass]="{ success: formatTask.status === 'completed', failure: formatTask.status === 'failed' }"
				>
					{{ formatTask.status === 'completed' ? 'check' : 'clear' }}
				</mat-icon>

				<mat-chip-list class="items-tags flex-grow">
					<mat-chip class="tag-item">
						<span>{{ EXPORT_TYPE_LABELS[format] | titlecase }}</span>
					</mat-chip>
				</mat-chip-list>

				<button
					color="primary"
					class="download-button"
					*ngIf="formatTask.status === 'completed'"
					(click)="$event.stopImmediatePropagation();
						item.type === CartItemType.VIDEO
						? downloadItem.emit({ cartItem: item })
						: downloadItem.emit({ cartItem: item, format: format })"
				>
					<mat-icon inline>download</mat-icon>
				</button>

				<button
					mat-button
					color="tertiary"
					*ngIf="formatTask.status === 'failed'"
					class="size-small wrapper-tiny round-border"
					(click)="retryTasks.emit()"
				>
					<mat-icon inline>replay</mat-icon>
					<ng-container i18n="Retry Button Text@@exportDownloadRetryButtonText">Retry</ng-container>
				</button>
			</div>

			<ng-container *localVar="item | transformObject : getItemTaskFromFormat: format as formatTask">
				<div *ngIf="formatTask.errors" class="errors">
					<ng-container *ngFor="let error of formatTask.errors">
						<div class="error">
							<strong>Error: </strong>{{error?.message}}
						</div>
					</ng-container>
				</div>
			</ng-container>
		</div>
	</div>
	<div
		*ngIf="[item] | transformObject : ExportDownloadUtils.filterItemsByStatus : TaskStatus.Failed as isFailed"
		class="action-details level-4"
	>
		<div class="failed-export pl-4 ml-8 format-row">
			<ng-container *ngIf="item.encodeTask?.errors[0]?.message as message else defaultMessage">
				{{message}}
			</ng-container>
			<ng-template #defaultMessage>
				<ng-container i18n="Default Error Message@@exportDownloadDefaultErrorMessage">Failed to Export</ng-container>
			</ng-template>
		</div>
	</div>
</mat-expansion-panel>
